/**
 * CataloguePrefetch — warms the shared supplier + item catalogues into the
 * TanStack Query cache as soon as a facility is active, so the first time a
 * supplier/item dropdown opens it renders instantly instead of flashing empty
 * then filling in (the reported dropdown flicker).
 *
 * It calls the same `useSuppliers` / `useAllItems` hooks every dropdown uses —
 * one source of truth, one cache entry per facility (30-min catalogue
 * staleTime), shared across the whole app. Rendered as an isolated null
 * component so the catalogue fetch settling does not re-render the AppShell
 * subtree (§8 re-render isolation); it just populates the cache the dropdowns
 * read from.
 */
import { useFacility } from "src/context/FacilityContext"
import { useSuppliers } from "src/queries/useSuppliers"
import { useAllItems } from "src/queries/useItems"

const CataloguePrefetch: React.FC = () => {
  const { facility } = useFacility()
  // Fire-and-cache: results are read by the dropdowns via the shared query keys.
  useSuppliers(facility)
  useAllItems(facility)
  return null
}

export default CataloguePrefetch
